/**
 * Needed to consistify/fixup spaces from the URL we get from UploadAnyFile linked data
 * @example '/servlets/cgi/download/Repo/uuid/building with space.ifc' → '/servlets/cgi/download/Repo/uuid/building%20with%20space.ifc'
 * @example 'https://app.wistor.nl/servlets/cgi/download/Repo/uuid/building with space.ifc' → '/servlets/cgi/download/Repo/uuid/building%20with%20space.ifc'
 */
export function getEncodedPathName(path: string) {
  try {
    const url = new URL(path)
    return url.pathname
  } catch {
    return path.split('/').map(segment => encodeURIComponent(segment)).join('/')
  }
}

export function toAbsoluteUrl(url: string) {
  return new URL(url, window.location.origin).href
}
